"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const sendPoto_1 = __importDefault(require("./sendPoto"));
const chatEvents_1 = __importDefault(require("../../lib/chatEvents"));
const configureStore_1 = require("../../store/configureStore");
const SendForm = (props) => {
    const { socket } = props;
    const [message, setMessage] = (0, react_1.useState)('');
    const { room, secretKey } = (0, react_1.useContext)(configureStore_1.StoreContext);
    const sendMessage = (e) => {
        e.preventDefault();
        if (message.length > 0) {
            const Events = new chatEvents_1.default(socket, secretKey);
            Events.sendMessage(message, room);
            setMessage('');
        }
    };
    const handleMsg = (e) => {
        setMessage(e.target.value);
    };
    return (react_1.default.createElement("form", { "data-testid": "chat-form", onSubmit: sendMessage, style: {
            display: "flex",
            flexFlow: "row",
            justifyContent: "center",
            padding: "6px",
            background: "#DFD8CA",
            boxShadow: "rgb(206, 202, 194) -0px -1px"
        } },
        react_1.default.createElement("input", { type: "text", "data-testid": "chat-input", value: message, onChange: handleMsg, style: {
                flex: "3 0px",
                margin: "3px 3px 0 0",
                background: "#DFD8CA",
                fontSize: "1rem",
                border: "none",
                outline: "none",
            }, placeholder: "\uCC44\uD305 \uBA54\uC2DC\uC9C0\uB97C \uC785\uB825\uD558\uC138\uC694." }),
        react_1.default.createElement(sendPoto_1.default, { socket: socket })));
};
exports.default = SendForm;
